<template>
  <div class="bg-light releasenote section margin_80_55 mt-5 d-none">
    <div class="container">
      <div class="row ">
        <div class="col-xl-12 d-flex justify-content-center">
          <h2>Release Note</h2>
        </div>
      </div>
    </div>
  </div>
  <div class="section mt-5 margin_80_55">
    <div class="container-fluid">
      <div class="row page-padding pt-4">
        <div v-if="releaseNotes.length > 0" class="row releasenote-slider-menu d-flex w-100 ">
        <div class="col-3">
          <h5 class="py-2">Releases</h5>
          <ul class="list-group list-group-flush">
            <li :class="{selected : item.Id === selectedReleaseNote.Id }" @click="selectReleaseNote(item.Id)" v-for="(item, index) in releaseNotes" :key="item.Id" class="font-weight-bold list-group-item flex-wrap justify-content-between align-items-center">{{ item.Version }}<span v-if="index === 0" class="badge badge-primary badge-pill ml-lg-4 ml-1">Current</span></li>
          </ul>
        </div>
        <div class="slider col-9">
          <article class="release-container" v-if="selectedReleaseNote">
            <h2 class="">{{ selectedReleaseNote.Version }}</h2>
            <p v-if="selectedReleaseNote.ReleaseDate" class="mb-4 text-muted">{{ new Date(selectedReleaseNote.ReleaseDate).toLocaleDateString() }}</p>
            <span @click="onTagClick(item)" v-for="(item, index) in selectedReleaseNote.KeyWordList" :key="index" class="badge badge-pill badge-primary mr-1 cursor-pointer">#{{ item }}</span>
            <div v-html="selectedReleaseNote.Body"></div>
          </article>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReleaseService from '../services/release.service'
import _ from 'lodash'

export default {
  name: 'ReleaseNotes',
  data() {
    return {
      releaseNotes: [],
      selectedReleaseNote: {}
    }
  },
  mounted() {
    this.getReleaseNotes()
  },
  methods: {
    getReleaseNotes() {
      var vm = this
      ReleaseService.getReleaseList().then(response => {
        vm.releaseNotes = response.data.Object.releaseNotes
        if (vm.$route.params.Id) {
          vm.selectReleaseNote(this.$route.params.Id)
        } else {
          vm.selectReleaseNote(this.releaseNotes[0].Id)
        }
      }),
      error => {
        console.log(error)
      }
    },
    selectReleaseNote(Id) {
      this.selectedReleaseNote = _.find(this.releaseNotes, ['Id', parseInt(Id)])
      if (!this.selectedReleaseNote && this.releaseNotes.length > 0) {
        this.selectReleaseNote(this.releaseNotes[0].Id)
      }
    },
    onTagClick (String) {
      this.$store.dispatch('chnageSearchString', String)
    }
  },
}
</script>
  